module.exports = __webpack_public_path__ + "static/media/test.42b74cff.jpg";